var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { BaseComponent } from '../base.component';
import { MatDialogRef } from '@angular/material';
import { InputModalData, InputModalActions } from './input.modal.provider';
import { FormBuilder } from "@angular/forms";
var InputModalComponent = /** @class */ (function (_super) {
    __extends(InputModalComponent, _super);
    function InputModalComponent(dialogRef, actions, formBuilder, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.formBuilder = formBuilder;
        _this.data = Object.assign({}, data);
        if (_this.data.inputModalValue) {
            _this.value = _this.data.inputModalValue;
        }
        return _this;
    }
    InputModalComponent.prototype.ngOnInit = function () {
        this.form = this.formBuilder.group({
            'text': [null],
        });
    };
    InputModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    InputModalComponent.prototype.confirm = function (event) {
        var _this = this;
        if (this.data.isAsync) {
            var oldFunc_1 = event.complete;
            event.complete = function () {
                oldFunc_1();
                _this.dialogRef.close();
            };
            this.actions.confirm(event, this.value);
        }
        else {
            this.actions.confirm(event, this.value);
            this.dialogRef.close();
        }
    };
    return InputModalComponent;
}(BaseComponent));
export { InputModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/input.modal/input.modal.component.ts.pre-build-optimizer.js